import { FlowModuleItemType } from "@packages/flow-core/module";
import { NodeProps } from "reactflow";
import NodeCard from "../NodeCard";
import styles from "./index.less";
import { Button, Divider, Tooltip, message } from "antd";
import {
  DeleteOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import {
  EditInputFieldMap,
  EditNodeFieldType,
  FlowNodeInputItemType,
} from "@packages/flow-core/module/node/types";
import FieldEditModal from "../render/FieldEditModal";
import { memo, useState } from "react";
import { FlowNodeOutputTypeEnum } from "@packages/flow-core/module/node/constants";
import { useFlow } from "../FlowEdit/useFlow";
import TargetHandle from "../TargetHandle";

export default memo(function NodePluginOutput({
  data,
  selected,
}: NodeProps<FlowModuleItemType>) {
  const { moduleId, inputs } = data;
  const [open, setOpen] = useState(false);
  const {
    addModuleInput,
    deleteModuleInput,
    updateModuleInput,
    addModuleOutput,
    deleteModuleOutput,
    updateModuleOutput,
  } = useFlow();

  const [editFieldValue, setEditFieldValue] = useState<EditNodeFieldType>({});

  const createEditField: EditInputFieldMap = {
    key: true,
    name: true,
    description: true,
    dataType: true,
  };

  return (
    <>
      <NodeCard minWidth={300} selected={selected} forbitMenu {...data}>
        <Divider style={{ margin: 0 }} />
        <div className={styles.content}>
          <div>
            {inputs.map((input) => {
              return (
                <div
                  key={input.key}
                  className={`${styles["mb-7"]} ${styles["pos-rel"]}`}
                >
                  <TargetHandle
                    handleKey={input.key}
                    valueType={input.valueType}
                    moduleId={moduleId}
                  />
                  <span className={styles["ml-4"]}>{input.label}</span>
                  {input.description && (
                    <Tooltip title={input.description}>
                      <QuestionCircleOutlined className={styles["ml-4"]} />
                    </Tooltip>
                  )}
                  <SettingOutlined
                    className={styles["ml-4"]}
                    onClick={() => {
                      setEditFieldValue({
                        inputType: input.type,
                        valueType: input.valueType,
                        key: input.key,
                        label: input.label,
                        description: input.description,
                        required: input.required,
                      });
                      setOpen(true);
                    }}
                  />
                  <DeleteOutlined
                    className={styles["ml-4"]}
                    onClick={() => {
                      deleteModuleInput(moduleId, input.key);
                      deleteModuleOutput(moduleId, input.key);
                    }}
                  />
                </div>
              );
            })}
            <Button
              icon={<PlusOutlined />}
              onClick={() => {
                setEditFieldValue({});
                setOpen(true);
              }}
            >
              添加输出参数
            </Button>
          </div>
        </div>
      </NodeCard>
      <FieldEditModal
        field={createEditField}
        onClose={() => {
          setOpen(false);
        }}
        data={editFieldValue}
        onConfirm={(data) => {
          const newInput: FlowNodeInputItemType = {
            key: data.key!,
            valueType: data.valueType,
            label: data.label!,
            type: data.inputType!,
            required: data.required,
            description: data.description,
            edit: true,
            editField: createEditField,
          };
          const newOutput = {
            key: data.key!,
            valueType: data.valueType!,
            label: data.label!,
            type: FlowNodeOutputTypeEnum.source,
            edit: true,
            targets: [],
          };
          if (Object.keys(editFieldValue).length !== 0) {
            if (editFieldValue.key !== newInput.key) {
              const existed = inputs.find((item) => item.key === newInput.key);
              if (existed) {
                message.warning("字段Key不可重复");
                return;
              }
            }
            updateModuleInput(moduleId, editFieldValue.key!, newInput);
            updateModuleOutput(moduleId, editFieldValue.key!, newOutput);
          } else {
            const existed = inputs.find((item) => item.key === newInput.key);
            if (existed) {
              message.warning("字段Key不可重复");
              return;
            }
            addModuleInput(moduleId, newInput);
            addModuleOutput(moduleId, newOutput);
          }
          setOpen(false);
        }}
        visible={open}
      />
    </>
  );
});
